import React from 'react'
import PropTypes from 'prop-types'
import {Button} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {ArrowPinnedIcon} from '../icons'
import textStyles from '../../theme/foundations/textStyles'
import {useHeader} from '../../hooks/use-header'
import {noop} from '../../utils/utils'

/**
 * BackToTopLink component.
 * @param {object} scrollContainer - The container to scroll.
 * @param {object} scrollToRef - The reference to the element to scroll to.
 * @param {function} onClick - The function to be called when the link is clicked.
 * @returns {JSX.Element} The BackToTopLink component.
 */
const BackToTopLink = ({scrollContainer, scrollToRef, onClick = noop, ...rest}) => {
    const {headerWrapper} = useHeader()

    const scroll = () => {
        // Emit onClick to parent component
        onClick()

        let top = 0

        if (scrollToRef?.current) {
            top = scrollToRef.current.offsetTop - headerWrapper.clientHeight
        }

        // If there is custom scroll container - use it instead of window
        if (scrollContainer) {
            scrollContainer.scrollTo(0, top)
        } else {
            window.scrollTo(0, top)
        }
    }

    return (
        <Button
            variant="link"
            onClick={scroll}
            {...textStyles['Regular Medium']}
            leftIcon={<ArrowPinnedIcon width="1rem" height="1rem" transform="scaleY(-1)" />}
            {...rest}
        >
            <FormattedMessage defaultMessage="back to top" id="components.back_to_top" />
        </Button>
    )
}

BackToTopLink.propTypes = {
    scrollContainer: PropTypes.object,
    scrollToRef: PropTypes.object,
    onClick: PropTypes.func
}

export default BackToTopLink
